export const tokens = {
    status: {
        gap: 6,
        iconSize: 10,
        labelSize: 12,
    },
};
